import { useSelector } from 'react-redux'
import DVideoDetails from './DownloadReportCard/DVideoDetails'
import DSentimentScore from './DownloadReportCard/DSentimentScore'
import VEmotionsScore from './VEmotionsScore'
import DAtenyaAi from './DownloadReportCard/DAtenyaAi'
import DVEmotionsScore from './DownloadReportCard/DVEmotionsScore'
import DRiskScore from './DownloadReportCard/DRiskScore'
import DVideoLineChart from './DownloadReportCard/DVideoLineChart'
import DComments from './DownloadReportCard/DComments'
import { CommentBgImage } from 'assets'
import { useRef, useState } from 'react'
import { jsPDF } from 'jspdf'
import html2canvas from 'html2canvas'
import { Loader } from 'components'
import { useLocation, useParams } from 'react-router-dom'

function DownloadPdfReport() {
   const contentRef = useRef()
   const videoRedux = useSelector((state) => state.videoRedux)
   const { commentList } = videoRedux
   const [loading, setLoading] = useState(false)
   const location = useLocation()
   const params = useParams()

   const downloadPDF = async () => {
      setLoading(true) // Show loading animation

      const input = contentRef.current

      const canvas = await html2canvas(input, {
         scale: 2, // High quality
         useCORS: true,
         backgroundColor: null // Don't override background
      })

      const imgData = canvas.toDataURL('image/png')
      const pdf = new jsPDF('p', 'mm', 'a4')
      const imgWidth = 210 // A4 width
      const pageHeight = 297
      const imgHeight = (canvas.height * imgWidth) / canvas.width

      let heightLeft = imgHeight
      let position = 0

      // Draw black background on first page
      pdf.setFillColor(0, 0, 0) // RGB for black
      pdf.rect(0, 0, imgWidth, pageHeight, 'F') // Fill full page
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight)

      heightLeft -= pageHeight

      while (heightLeft > 0) {
         position -= pageHeight
         pdf.addPage()

         // Fill background with black on new page
         pdf.setFillColor(0, 0, 0)
         pdf.rect(0, 0, imgWidth, pageHeight, 'F')

         pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight)
         heightLeft -= pageHeight
      }

      pdf.save(`${params?.id}.pdf`)
      setLoading(false) // Hide loading animation
   }

   // const downloadPDF = async () => {
   //    setLoading(true) // Show loading animation

   //    const input = contentRef.current
   //    window.scrollTo(0, 0) // Ensure proper rendering of images

   //    const canvas = await html2canvas(input, {
   //       scale: 2, // Higher scale for better quality
   //       useCORS: true, // Ensure external images are captured
   //       logging: false, // Reduce console logs for performance
   //    })

   //    const imgData = canvas.toDataURL('image/png')
   //    const pdf = new jsPDF('p', 'mm', 'a4')
   //    const imgWidth = 210 // A4 width in mm
   //    const pageHeight = 297 // A4 height in mm
   //    const imgHeight = (canvas.height * imgWidth) / canvas.width

   //    let heightLeft = imgHeight
   //    let position = 0

   //    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight)
   //    heightLeft -= pageHeight

   //    while (heightLeft > 0) {
   //       position -= pageHeight
   //       pdf.addPage()
   //       pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight)
   //       heightLeft -= pageHeight
   //    }

   //    pdf.save('video-analysis-report.pdf')
   //    setLoading(false) // Hide loading animation
   // }

   // const downloadPDF = async () => {
   //    if (!contentRef.current) return

   //    try {
   //       // Capture the full page
   //       const canvas = await html2canvas(contentRef.current, { scale: 2 })
   //       const imgData = canvas.toDataURL('image/png')

   //       // Convert to PDF
   //       const pdf = new jsPDF('p', 'mm', 'a4')
   //       const imgWidth = 210 // A4 width in mm
   //       const imgHeight = (canvas.height * imgWidth) / canvas.width // Maintain aspect ratio
   //       pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight)
   //       pdf.save('screenshot.pdf')
   //    } catch (error) {
   //       console.error('Error capturing screenshot:', error)
   //    }
   // }
   return (
      <div className="">
         {loading && (
            <Loader message={'Your report is being downloaded. Please wait a moment...'} />
         )}
         <button
            className="btn btn-primary my-3 mx-3 rounded-5"
            onClick={() => {
               downloadPDF()
            }}>
            Download Report
         </button>
         <div className="container-fluid" ref={contentRef} style={{ backgroundColor: 'black' }}>
            <DVideoDetails />
            <div>
               <div className="row mt-3">
                  <div className=" report-card d-flex gap-3 align-items-baseline flex-wrap">
                     <DSentimentScore />
                     <DRiskScore />
                  </div>
                  <div className="mt-3">
                     <DVEmotionsScore />
                  </div>
               </div>
            </div>
            <div className="mt-4">
               <DAtenyaAi />
            </div>
            <div className="mt-4 position-relative">
               <DVideoLineChart />
            </div>
            <div className="mt-4 position-relative">
               {/* <div className="comment-bg-image"></div> */}
               <img className="comment-bg-image" src={CommentBgImage} alt="CommentBgImage" />
               <DComments />
            </div>
         </div>
      </div>
   )
}

export default DownloadPdfReport
